import {ShieldLockIcon} from '@primer/octicons-react'
import {Link} from '@primer/react'

export type PreviewFeaturesRestriction = {
  scope: 'organization' | 'enterprise'
  settingsUrl: string | null
}

export function PreviewRequiredNote() {
  return (
    <span className="d-flex flex-items-center gap-1 color-fg-muted text-small">
      <ShieldLockIcon size={16} /> Requires preview features
    </span>
  )
}

export function PreviewFeaturesNotice({restriction}: {restriction?: PreviewFeaturesRestriction | null}) {
  const enterprise = restriction?.scope === 'enterprise'
  const message = restriction
    ? enterprise
      ? 'Preview features are disabled by your enterprise.'
      : 'Preview features are not enabled for this organization.'
    : 'Requires organization opt-in for preview features'

  return (
    <span className="d-flex flex-items-start gap-1 color-fg-muted text-small">
      <ShieldLockIcon size={16} className="flex-shrink-0" />
      <span>
        {message}
        {restriction?.settingsUrl ? (
          <>
            {' '}
            <Link href={restriction.settingsUrl} inline>
              {enterprise ? 'View enterprise settings' : 'Manage preview features'}
            </Link>
            .
          </>
        ) : restriction ? (
          <span>{` Contact ${enterprise ? 'an enterprise' : 'an organization'} owner to enable them.`}</span>
        ) : null}
      </span>
    </span>
  )
}
